import React from 'react';
import TimelineCalendar from '../../components/features/events/TimelineCalendar';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import { CalendarIcon, LocationIcon } from '../../components/ui/Icons';
import evenementAVenirData from '../../data/evenementAVenirData.json';

export default function EvenementsAVenirPage() {
  return (
    <div className="space-y-12 animate-fade-in px-4">
      <div className="text-center space-y-2 max-w-3xl mx-auto">
        <h1 className="font-title text-3xl sm:text-4xl font-extrabold text-acem-primary-dark">
          Événements à Venir
        </h1>
        <p className="text-sm sm:text-base text-acem-muted">
          Découvrez la liste chronologique des prochains événements et activités de l'ACEM Fès.
        </p>
      </div>

      {/* Prochain événement à la une (si configuré) */}
      {evenementAVenirData && evenementAVenirData.titre && (
        <div className="max-w-4xl mx-auto space-y-6">
          <Card variant="elevated" className="p-6 sm:p-10 space-y-6">
            <div className="flex flex-wrap gap-2.5">
              {evenementAVenirData.date && (
                <Badge variant="success" className="px-3 py-1 text-xs">
                  <CalendarIcon className="w-3.5 h-3.5 mr-1" />
                  {evenementAVenirData.date}
                </Badge>
              )}
              {evenementAVenirData.heure && (
                <Badge variant="primary" className="px-3 py-1 text-xs">
                  {evenementAVenirData.heure.toLowerCase().includes('publication') ? '🌐 ' : '⏰ '}
                  {evenementAVenirData.heure}
                </Badge>
              )}
              {evenementAVenirData.lieu && (
                <Badge variant="accent" className="px-3 py-1 text-xs">
                  <LocationIcon className="w-3.5 h-3.5 mr-1" />
                  {evenementAVenirData.lieu}
                </Badge>
              )}
            </div>

            <div>
              <h2 className="font-title text-2xl sm:text-3xl font-extrabold text-acem-primary-dark mb-3">
                {evenementAVenirData.titre}
              </h2>
              <p className="text-sm sm:text-base text-acem-text/85 leading-relaxed">
                {evenementAVenirData.descriptionComplete}
              </p>
            </div>

            {/* Programme détaillé */}
            {evenementAVenirData.programme && (
              <div className="space-y-4 pt-4 border-t border-acem-border/60">
                <h3 className="font-title text-lg font-bold text-acem-primary-dark">
                  📋 Programme Détaillé
                </h3>
                {Array.isArray(evenementAVenirData.programme) ? (
                  <div className="space-y-3">
                    {evenementAVenirData.programme.map((prog, idx) => (
                      <div
                        key={idx}
                        className="flex flex-col sm:flex-row items-start sm:items-center rounded-xl overflow-hidden border border-acem-border bg-acem-surface-container-low shadow-sm"
                      >
                        <div className="bg-acem-primary text-white font-bold text-sm px-4 py-3 sm:py-4 w-full sm:w-28 text-center flex-shrink-0">
                          {prog.heure}
                        </div>
                        <div className="p-3.5 sm:p-4 flex-1">
                          <h4 className="font-bold text-sm text-acem-text mb-0.5">{prog.activite}</h4>
                          <p className="text-xs text-acem-muted">{prog.details}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="p-4 rounded-xl border border-acem-border bg-acem-surface-container-low text-xs sm:text-sm text-acem-text font-semibold">
                    {evenementAVenirData.programme}
                  </div>
                )}
              </div>
            )}
          </Card>

          <div className="border-t-2 border-dashed border-acem-border pt-8 text-center">
            <h2 className="font-title text-2xl sm:text-3xl font-bold text-acem-primary-dark">
              Chronologie des Événements à Venir
            </h2>
          </div>
        </div>
      )}

      {/* Timeline des prochains événements */}
      <TimelineCalendar onlyUpcoming={true} />
    </div>
  );
}
